<script>
import Vue from "vue"
import { h } from 'vue'
import { copy } from '@/utils/index'
import render from '@/render/render.js'
import ruleTrigger from '@/render/ruleTrigger.js'
import components from '@/packages'
import { EventHub, getAction } from '@/utils'
// 全局注册业务组件
Object.keys(components).map(item => {
    Vue.component(item, components[item])
})
// 系统组件typeId
const systemInput =  [ 'ID', 'CREATE_BY', 'CREATE_TIME', 'UPDATE_BY', 'UPDATE_TIME', 'DEPT_CODE' ]
// 显隐下拉框点击
function hiddenAndShow(value, extra, preValue = []) {
    console.log(preValue)
    // 兼容后端formData传入空对象（老数据）
    const isEmptyObj = JSON.stringify(preValue) === '{}'
    if(isEmptyObj) preValue = []
    let _value, _preValue, flag
    const { typeId } = extra
    if (typeId === "RADIO" || typeof value === "string") {
        _value = value
        if (preValue && preValue.length) {
            flag = value ? "=" : "-"
            _preValue = preValue
        } else {
            flag = "+"
        }
    } else {
        const valueArr = value.map((item) => item.value)
        const preValueArr = preValue.map((item) => item.value)
        if (preValue.length > value.length) {
            flag = "-"
            if (typeId === "CHECKBOX") {
                _value = preValue.filter((val) => !value.includes(val))[0]
            } else if (typeId === "SELECT_V2") {
                _value = preValueArr.filter((val) => !valueArr.includes(val))[0]
            }
        } else if (preValue.length === value.length) {
            flag = "=";
            _value = valueArr[0]
            _preValue = preValueArr[0]
        } else {
            flag = "+"
            if (typeId === "CHECKBOX") {
                _value = value[value.length - 1]
            } else if (typeId === "SELECT_V2") {
                _value = valueArr[valueArr.length - 1]
            }
        }
    }
    const _key = extra.__vModel__ + "$" + _value + "^" + extra.typeId
    const fieldAndValStr = this.formRules.map(item => item.opsRules.filter(val => val).map((val) => val.split("$")[0] + "$" + val.split("$")[1]).join("/")).join("/")
    const inRulesStr = this.formRules.map(item => item.opsRules.filter(val => val).map((val) => val.split("$")[2]).join("$")).join("$")
    const fields = copy(this.configCopy)
    const showItemKey = fields.map((item) => item.__vModel__)
    const form = copy(this.form)
    //循环递归遍历
    const fieldAndValStrArr = fieldAndValStr.split("/")
    function recursionKey(MapKey, _this, isDelete) {
        MapKey.forEach((key) => {
            if (fieldAndValStr.includes(key)) {
                //显隐映射的组件也被配置了控制其他组件的显隐规则
                fieldAndValStrArr.forEach((str, strSub) => {
                    if (str.includes(key)) {
                        const _MapKey = inRulesStr.split("$")[strSub].split("&")
                        recursionKey(_MapKey, _this, isDelete)
                    }
                })
            }
            _this.formConfig.forEach((item) => {
                if (item.__vModel__ === key) item.__config__.defaultValue = undefined
            })
            if (isDelete) {
                const _sub = showItemKey.indexOf(key)
                if (_sub >= 0) {
                    showItemKey.splice(_sub, 1)
                    delete form[key]
                    delete _this.rules[key]
                }
            } else {
                delete form[key]
                delete _this.rules[key]
            }
        })
    }
    let _preKey
    if (flag === "=") {
        _preKey = extra.__vModel__ + "$" + _preValue + "^" + extra.typeId
        if (fieldAndValStr.includes(_preKey)) {
            //此字段组件的该选项值被被配置了显隐规则
            const _index = fieldAndValStr.split("/").indexOf(_preKey)
            const preMapKey = inRulesStr.split("$")[_index].split("&")
            recursionKey(preMapKey, this, true)
        }
    }
    let _fields
    if (fieldAndValStr.includes(_key)) {
        //此字段组件的该选项值被被配置了显隐规则
        const _index = fieldAndValStr.split("/").indexOf(_key)
        const mapKey = inRulesStr.split("$")[_index].split("&")
        if (flag === "+" || flag === "=") {
            //选择时 显示组件
            const _showItemKey = [...showItemKey, ...mapKey]
            const _newfields = this.formConfig.filter((item) =>
                _showItemKey.includes(item.__vModel__)
            );
            const oldFieldsMap = {};
            fields.forEach((item) => (oldFieldsMap[item.__vModel__] = item));
            _fields = _newfields.map((item) => {
                const _item = oldFieldsMap[item.__vModel__];
                if (item.typeId === "Table_List")
                item.__config__.defaultValue = copy(
                    this.formData[item.__vModel__]
                );
                return _item ? _item : item;
            });
            const defaultValueObj = {};
            mapKey.forEach((_key) => {
                const _filterItem = this.formConfig.filter((item) => item.__vModel__ === _key)[0]
                if (_filterItem) defaultValueObj[_key] = _filterItem.__config__.defaultValue;
            });
            mapKey.forEach((val) => (form[val] = defaultValueObj[val]));
        } else {
            //清空 或 删除时 隐藏组件
            _fields = fields.filter((item) => !mapKey.includes(item.__vModel__))
            recursionKey(mapKey, this)
        }
        this.$set(this, "configCopy", _fields)
        this.form = form
        this.buildRules(_fields, this.rules)
    } else {
        if (flag === "=" && fieldAndValStr.includes(_preKey)) {
            //此字段组件的该选项值被被配置了显隐规则
            const _newfields = this.formConfig.filter((item) =>
                showItemKey.includes(item.__vModel__)
            );
            const oldFieldsMap = {}
            fields.forEach((item) => (oldFieldsMap[item.__vModel__] = item))
            _fields = _newfields.map((item) => {
                const _item = oldFieldsMap[item.__vModel__]
                return _item ? _item : item
            })
            this.$set(this, "configCopy", _fields)
            this.form = form
            this.buildRules(_fields, this.rules)
        }
    }
}
// 初始显隐显示 或者 formData变化后
function defaultHidenVisible (formRules, formConfig) {
    // 深拷贝传入的props.formConfig
    let configCopy = copy(formConfig)
    // 先根据formPerms表单权限来确定formConfig
    configCopy = configCopy.map(item => {
        const permsItem = this.formPerms.find(i => i.id === item.__vModel__)
        if (permsItem) {
            if (permsItem.perm === 'H' || permsItem.isHide) { // 需要隐藏
                item = undefined
            } else if (permsItem.perm === 'R') { // 需要只读
                item.disabled = true
                item.readonly = true
            } else if (permsItem.required) { // 需要必填
                item.__config__.required = true
            }
        }
        // 系统组件不允许修改（OA老数据兼容）
        if (item && systemInput.includes(item.typeId)) {
            item.disabled = true
            item.readonly = true
        }
        return item
    }).filter(item => item)
    if(Array.isArray(formRules) && formRules.length) {
        const inRules = formRules.map(item => item.opsRules.filter(val => val).map((val) => val.split("$")[2]).join("$")).join("$")
        const inRulesSelected = []
        if(this.formData && Object.keys(this.formData).length) {
            for (let key in this.formData) {
                let arr = this.formData[key]
                // 兼容单选框多选框的值为字符串 将字符串转变为数组 str => [{key: str, value: str}]
                const configCopyItem = configCopy.find(item => item.__vModel__ === key)             
                if(configCopyItem && configCopyItem.typeId === 'RADIO' && arr) {
                    arr = [{label: arr, key: arr, value: arr}]
                }
                if(Array.isArray(arr)) {
                    const fieldItem = configCopy.filter(item => item.__vModel__ === key)[0]
                    arr.forEach(ele => {
                        if (fieldItem) {
                            const center = "$" + ele.value + "^" + fieldItem.typeId + "$"
                            formRules.forEach((rule) => {
                                rule.opsRules.forEach((item) => {
                                    if (item && item.includes(key + center))
                                    inRulesSelected.push(...item.split(center)[1].split("&"))
                                })
                            })
                        }
                    })
                }
            }
            configCopy = configCopy.filter(item => {
                const key = item.__vModel__
                return !inRules.includes(key) || inRulesSelected.includes(key)
            })
        } else {
            configCopy = configCopy.filter(item => !inRules.includes(item.__vModel__))
        }
    }
    return configCopy
}
// 读取根目录配置文件
function buildListeners (item) {
    const config = item.__config__
    // 如果props有methods属性
    const methods = this.methods || {}
    const listeners = {}
    // 给methods中的方法绑定this和event
    Object.keys(methods).forEach(key => {
        listeners[key] = (event) => methods[key].call(this, event, this.form)
    })
    // 响应 render.js 中的 vModel $emit('input', val) 并改变表单值
    listeners.input = (event) => setValue.call(this, event, item, config)
    return listeners
}

function setValue(event, scheme, config) {
    // 显隐组件选择
    const rulesTypes = ["SELECT", "SELECT_V2", "RADIO"]
    const { typeId } = scheme
    if (rulesTypes.includes(typeId)) {
        // 先抄袭沿用citydo代码的逻辑规则
        hiddenAndShow.call(this, event, scheme, this.form[scheme.__vModel__])
    }
    // 现在表单渲染是改变props（config）的值触发组件整体重新渲染（有污染） tip: 是否要深拷贝靠触发组件内的data触发整体渲染？ 已修改done
    this.$set(config, 'defaultValue', event)
    this.$set(this.form, scheme.__vModel__, event)
    // 发布事件（计算组件中用到）
    this.eventHub.emit(scheme.__vModel__, event)
}

function renderChildren (h, item) {
    const config = item.__config__ 
    if (!Array.isArray(config.children)) return null
    return renderFormItem.call(this, h, config.children)
}

const design = {
    colFormItem(h, item) {
        const config = item.__config__
        const listeners = buildListeners.call(this, item)
        const { option = {} } = this.$attrs
        const labelWidth = config.labelWidth || option.labelWidth //__config里没有，则取option中的labelWidth，默认120px
        return (
            <el-col span={config.span}>
                <el-form-item label-width={labelWidth ? `${labelWidth}px` : `120px`} prop={item.__vModel__}
                    label={config.showLabel ? config.label : ''}>
                    <render 
                        info={this.form} 
                        formSlot={{scopedSlots: this.$scopedSlots}} 
                        eventHub={this.eventHub} 
                        conf={{ ...item, readonly: this.readonly}} 
                        {...{ on: listeners, attrs: this.$attrs }}
                    />
                </el-form-item>
            </el-col>
        )
    },
    rowFormItem(h, item) {
        let child = renderChildren.call(this, h, item)
        if(item.type === 'flex') {
            child = (
                <el-row type={item.type} justify={item.justify} align={item.align}>{child}</el-row>
            )
        }
        return (
            <el-col span={item.span}>
                <el-row gutter={item.gutter}>
                    {child}
                </el-row>
            </el-col>
        )
    }
}

function renderFormItem (h, config) {
    return config.map(item => {
        const  { __config__: { layout } } = item
        const fun = design[layout]
        if(fun) {
            return fun.call(this, h, item)
        }
        throw new Error(`__config__里少了layout属性`)
    })
}


function renderFrom (h) {
    const { configCopy, rules, readonly, componentKey } = this
    const { option = {} } = this.$attrs
    const { labelPosition, labelWidth, size } = option
    return (
        <el-form
            ref="elForm"
            key={componentKey}
            size={size}
            label-position={labelPosition}
            disabled={readonly}
            label-width={`${labelWidth}px`}
            props={{ model: this.form }}
            rules={rules}
        >
            <el-row type="flex" justify="start" style="flex-wrap: wrap">
                {
                    renderFormItem.call(this, h, configCopy)
                }
            </el-row>
        </el-form>
    )
}

export default {
    name: 'el-dynamic-form',
    props: {
        // 表单 fileds
        formConfig: {
            type: Array,
            required: true
        },
        // 表单model 
        formData: {
            type: Object,
            default: () => {},
        },
        // API配置相关 已经v-bind attr
        // option: {
        //     type: Object,
        //     default: () => {}
        // },
        // 表单额外要监听的方法
        methods: {
            type: Object,
            default: () => {}
        },
        readonly: {
            type: Boolean,
            default: false
        },
        // 显隐规则
        formRules: {
            type: Array,
            default: () => []
        },
        formPerms: {
            type: Array,
            default: () => []
        }
    },
    data() {
        // 显隐配置读取过滤configCopy
        const { formRules, formConfig } = this
        let configCopy = defaultHidenVisible.call(this, formRules, formConfig)
        // 显隐配置读取过滤结束
        const data = {
            form: {},
            rules: {},
            configCopy,
            eventHub: new EventHub(),
            // 用于表单内部刷新
            componentKey: 0
        }
        this.buildRules(data.configCopy, data.rules)
        // 如果有传 获取中枢配置信息 的接口 请求并保存在window下
        const { option: { api } } = this.$attrs
        if(api.getEventCenterConfig) {
           const [ action ] = getAction(api.getEventCenterConfig)
           action().then(res => {
                window.$centerConfig = res.data
           })
        }
        return data
    },
    watch: {
        formConfig: {
            handler: function (value) {
                if(!value) throw ('formConfig must be required')  
                if(!Array.isArray(value)) throw ('formConfig must an Array')
                // this.buildRules(value, this.rules)
            },
            immediate: true
        },
        formData: {
            handler: function (value) {
                if(value === undefined) return
                // 传值命中显隐的话改变configCopy和rules
                this.configCopy = defaultHidenVisible.call(this, this.formRules, this.formConfig)
                this.buildRules(this.configCopy, this.rules)
                // configCopy end
                const copyValue = copy(value)
                // form赋值并为表单添加默认值
                this.form = this.initFormData(this.configCopy, copyValue)
            },
            immediate: true,
            deep: true
        }
    },
    methods: {
        initFormData(fields, value) {
            fields.map(item => {
                const itemConfig = item.__config__
                const { defaultValue } = itemConfig
                // 为表单添加默认值
                if(item.__vModel__ && defaultValue) {
                    // 如果该formData有值就不使用默认值
                    if(value[item.__vModel__]) return
                    value[item.__vModel__] = itemConfig.defaultValue
                }
                if (itemConfig.children) this.initFormData(itemConfig.children, value)
            })
            return value
        },
        buildRules(fields, rules) {
            fields.map(field => {
                const config = field.__config__
                if (Array.isArray(config.regList)) {
                    if (config.required) {
                        const required = { required: config.required, message: field.placeholder }
                        required.message === undefined && (required.message = `${config.label}不能为空`)
                        config.regList.push(required)
                    }
                    // 自定义的校验
                    if(config.regular) {
                        config.regList.push({pattern: config.regular, message: config.errorMessage})
                    }
                    rules[field.__vModel__] = config.regList.map(item => {
                        item.pattern && (item.pattern = eval(item.pattern))
                        item.trigger = ruleTrigger[config.tag] || 'blur'
                        return item
                    })
                }
                if (config.children) this.buildRules(config.children, rules)
                const { props } = field
                // 卡片容器
                if(field.typeId === 'CARD') {
                    this.buildRules(props.rows, rules)
                }
                // 标签容器
                if(field.typeId === 'TABS' || field.typeId === 'COLLAPSE') {
                    props.tabs.map(item => {
                        this.buildRules(item.rows, rules)
                    })
                }
                // 表格
                if(field.typeId === 'Table_List') {
                    this.buildRules(props.columns, rules)
                }
            })
        },
        submitForm() {
           return this.form
        },
        validate(val) {
            return this.$refs['elForm'].validate(val)
        },
        reloadForm(){
            this.componentKey += 1
        }
    },
    render(h) {
        return renderFrom.call(this, h)
    }
}
</script>
<style scoped>
::v-deep .el-form-item__label {
    color: #000000;
}
::v-deep .el-input__inner {
    color: #000000;
}
::v-deep .el-textarea__inner {
    color: #000000;
}
::v-deep .el-range-input {
    color: #000000;
}
::v-deep .el-tag--info {
    color: #000000;
}
</style>
